(function(){
  "use strict";
  function czk(n){ return Math.round(n).toLocaleString("cs-CZ") + " Kč"; }

  /* gallery */
  var main = document.getElementById("sgMain");
  document.querySelectorAll("[data-thumb]").forEach(function(b){
    b.addEventListener("click", function(){
      if(main){ main.src = b.getAttribute("data-thumb"); }
      document.querySelectorAll("[data-thumb]").forEach(function(x){ x.setAttribute("aria-current", x===b ? "true" : "false"); });
    });
  });

  /* quantity */
  var qty = document.getElementById("sgQty");
  if(qty){
    document.querySelectorAll("[data-q]").forEach(function(b){
      b.addEventListener("click", function(){
        var n = parseInt(qty.value,10) || 1;
        n = b.getAttribute("data-q")==="+" ? n+1 : Math.max(1, n-1);
        qty.value = n;
      });
    });
  }

  /* plan toggle */
  var box = document.getElementById("sgBuy");
  var once = document.getElementById("sgPlanOnce"), sub = document.getElementById("sgPlanSub");
  var planInput = document.getElementById("sgPlanInput");
  var mainPrice = document.getElementById("sgMainPrice"), per = document.getElementById("sgPer"),
      sbPrice = document.getElementById("sgSbPrice"), planNote = document.getElementById("sgPlanNote");
  var P = box ? parseFloat(box.getAttribute("data-price")) : 0;
  var PS = box ? parseFloat(box.getAttribute("data-sub-price")) : 0;
  var DAYS = box ? parseInt(box.getAttribute("data-days"),10) || 30 : 30;
  /* ID předplatného si uložíme hned na začátku — aplikace Seal Subscriptions
     si spravuje vlastní selling_plan inputy a ten náš z formuláře později
     odstraní. */
  var PLAN = planInput ? planInput.value : "";
  var form = planInput ? planInput.closest("form") : document.querySelector(".sg form[action*='/cart/add']");
  var subscribed = false;
  function setPlan(s){
    if(!once || !sub) return;
    subscribed = !!s;
    once.setAttribute("aria-pressed", s?"false":"true");
    sub.setAttribute("aria-pressed", s?"true":"false");
    var price = s ? PS : P;
    if(mainPrice) mainPrice.textContent = czk(price);
    if(sbPrice) sbPrice.textContent = czk(price);
    if(per) per.textContent = Math.round(price/DAYS) + " Kč na den";
    if(planNote) planNote.hidden = !s;
    if(planInput && planInput.isConnected) planInput.disabled = !s;
  }
  if(once && sub){
    once.addEventListener("click", function(){ setPlan(false); });
    sub.addEventListener("click", function(){ setPlan(true); });
    setPlan(false);
  }

  /* Proto hidden input vytvoříme až v momentě odeslání formuláře —
     tak se do košíku dostane přesně to, co je vybrané. */
  if(form){
    form.addEventListener("submit", function(){
      var el = form.elements;
      for(var i=0;i<el.length;i++){
        var nm = el[i].name || "";
        if(nm === "selling_plan" || nm.indexOf("subs_") === 0){ el[i].disabled = true; }
      }
      if(subscribed && PLAN){
        var inp = document.createElement("input");
        inp.type = "hidden"; inp.name = "selling_plan"; inp.value = PLAN;
        form.appendChild(inp);
      }
    }, true);
  }

  /* bundle add */
  document.querySelectorAll("[data-bundle]").forEach(function(btn){
    btn.addEventListener("click", function(){
      var ids = btn.getAttribute("data-bundle").split(",");
      var items = ids.map(function(id){ return {id: parseInt(id,10), quantity: 1}; });
      var orig = btn.textContent;
      btn.textContent = "Přidávám…"; btn.disabled = true;
      fetch("/cart/add.js", {method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({items: items})})
        .then(function(r){
          if(r.ok){ window.location.href = "/cart"; }
          else { btn.textContent = "Nepodařilo se — zkus to znovu"; btn.disabled = false; setTimeout(function(){ btn.textContent = orig; }, 2500); }
        }).catch(function(){ btn.textContent = "Nepodařilo se — zkus to znovu"; btn.disabled = false; setTimeout(function(){ btn.textContent = orig; }, 2500); });
    });
  });

  /* faq */
  document.querySelectorAll(".sg .acc-item").forEach(function(item){
    var q = item.querySelector(".acc-q");
    if(!q) return;
    q.addEventListener("click", function(){
      var open = item.getAttribute("data-open")==="true";
      item.setAttribute("data-open", open?"false":"true");
      q.setAttribute("aria-expanded", open?"false":"true");
    });
  });

  /* sticky bar */
  var st = document.getElementById("sgSticky"), hero = document.getElementById("koupit");
  if(st && hero && "IntersectionObserver" in window){
    new IntersectionObserver(function(e){
      st.classList.toggle("on", !e[0].isIntersecting);
    }, {rootMargin:"-120px 0px 0px 0px"}).observe(hero);
  }
})();
